var trimAboveMaxLength = function trimAboveMaxLength(value, maxLength) {
  return value.slice(0, maxLength);
};
var joinParameters = function joinParameters(params) {
  return params.filter(function (param) {
    return param;
  }).join('.');
};
function cpfFormatter(formattedValue) {
  var cpfMaxLength = 11;
  var reg = /(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/;
  return trimAboveMaxLength(formattedValue.replace(/\D/g, ''), cpfMaxLength).replace(reg, function (match, p1, p2, p3, p4) {
    var result = joinParameters([p1, p2, p3]);
    if (p4) {
      result += "-".concat(p4);
    }
    return result;
  });
}
function cnpjFormatter(formattedValue) {
  var cnpjMaxLength = 14;
  var reg = /(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/;
  return trimAboveMaxLength(formattedValue.replace(/\D/g, ''), cnpjMaxLength).replace(reg, function (match) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    var p1 = params[0],
      p2 = params[1],
      p3 = params[2],
      p4 = params[3],
      p5 = params[4];
    var result = joinParameters([p1, p2, p3]);
    if (p4) {
      result += "/".concat(p4);
    }
    if (p5) {
      result += "-".concat(p5);
    }
    return result;
  });
}
function mexicanDocumentIdFormatter(formattedValue) {
  return formattedValue.replace(/[^a-zA-Z0-9]/g, '').substring(0, 18);
}
module.exports = {
  cpfFormatter: cpfFormatter,
  cnpjFormatter: cnpjFormatter,
  mexicanDocumentIdFormatter: mexicanDocumentIdFormatter
};